const categoryDummy = [
  { id: 1, label: '조소' },
  { id: 2, label: '한국화' },
  { id: 3, label: '동양화' },
  { id: 4, label: '서양화' },
  { id: 5, label: '일러스트' },
  { id: 6, label: '디자인' },
  { id: 7, label: '공예' },
  { id: 8, label: '수채화' },
];
export default categoryDummy;
